import React from 'react';
import cssClass from './RoadmapEditor.module.css';
import EditorCanvas from './EditorCanvas';
import Sidebar from './sidebar/Sidebar';
import useWindowDimensions from '../hooks/useWindowDimensions';
import backIcon from '../assets/back.svg';
import desktopIcon from '../assets/desktop-icon.svg';
import EditorCanvasHeader from './EditorCanvasHeader';

/**
 * RoadmapEditor Component
 *
 * This component serves as the main container for the roadmap editing interface.
 * It includes a header, a sidebar, and an editor canvas for drawing.
 * It also restricts editing on smaller screens for a better user experience.
 *
 * @component
 * @returns {JSX.Element} The rendered RoadmapEditor component.
 */
const RoadmapEditor = () => {
  // Get window width and height using a custom hook
  const { width: windowWidth, height: windowHeight } = useWindowDimensions();

  return (
    <>
      {/* If screen width is less than 768px, show a message blocking access */}
      {windowWidth < 768 ? (
        <div className={cssClass['page-edit-blocker']}>
          <a href="/">
            <img src={backIcon} alt="" className={cssClass['page-back-icon']} />
          </a>

          <img
            src={desktopIcon}
            alt="Desktop Icon"
            className={cssClass['desktop-icon']}
          />
          <div>Switch to larger devices to draw</div>
        </div>
      ) : (
        <>
          {/* Header component - Fixed at the top */}
          <EditorCanvasHeader />
          <div className={cssClass['main-container']}>
            {/* Sidebar component - Contains tools for roadmap editing */}
            <Sidebar />

            {/* Main roadmap editing canvas */}
            <div className={cssClass['roadmap-canvas']}>
              <EditorCanvas />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RoadmapEditor;
